import {EnvironmentSettings} from './environment-settings';

export const localEnvironmentSettings = {
    apiUrl: 'https://api-demo.everydatastore.org/restful/',
    demoMode: true,
};
